import { useEffect } from "react";

const getIframeUrl = (poid) => {
    return `/dyfo/embedded/Page/Show/b06488be-0431-ee11-a027-20c19b8466aa?dyfopoid=${poid ?? "null"}`;
}

export const SeniorenplatformVragenLijst = ({ poId, ...props }) => {

    useEffect(() => {

        window.addEventListener("message", function (event) {
            if (event.data == "DyFoPageReadyToClose")
                setTimeout(() => {
                    //Refresh page
                    window.location.reload();
                }, 2000);
        });

    }, []);

    return <div className="c-seniorenplatform-vragenlijst-wrap">
        <iframe id="seniorenplatform-vragenlijst" src={getIframeUrl(poId)}></iframe>
    </div>;
}